import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { Badge, Carousel, Col, Row } from 'antd';
import axios from 'axios';
import { Link } from 'react-router-dom';

export type Props = {
  items?: any;
  from?: string;
};

const ShopListWithProducts: React.FC<Props> = (props) => {
  const { items = [], from } = props;
  const [fromPage, setFromPage] = useState<any>('');
  useEffect(() => {
    setFromPage(from);
    getPromotion(items);
  }, [items]);

  const [shopPromotion, setShopPromotion] = useState<any>([]);

  const getPromotion = async (items: any) => {
    const data =
      items.length > 0
        ? items?.map((item: any) => {
            return { sellerId: item?.code };
          })
        : [];

    if (data.length > 0) {
      const promotions = await axios.post(
        `/promotions/seller/has-promotion`,
        { sellers: data }
      );
      setShopPromotion(promotions);
    }
  };

  const getShopPromotion = (sellerId: any) => {
    let shops = shopPromotion?.data?.filter(
      (item: any) => item?.sellerId === sellerId
    );
    const text = 'ร้านค้าเข้าร่วมโปรโมชั่น';
    return <div>{shops[0].joinPromotion ? text : ''}</div>;
  };

  const checkPromotion = (sellerId: any) => {
    if (sellerId && shopPromotion?.data) {
      let shops = shopPromotion?.data?.filter(
        (item: any) => item?.sellerId === sellerId
      );
      return shops[0]?.joinPromotion;
    }
    return false;
  };

  const ShopDetailForm = (item: any) => {
    return (
      <>
        <div className={styles.mainWrapper}>
          <div className={styles.topWrapper}>
            <div className={styles.left}>
              <div className={styles.name}>{item.name}</div>
              <div className={styles.distance}>
                <img
                  className={styles.distanceIcon}
                  src="/images/location_on_24px.svg"
                  alt=""
                />
                <div className={styles.text}>
                  {item.dist?.calculated?.toFixed(1)} ก.ม.
                </div>
              </div>
            </div>
            <div className={styles.right} style={{ paddingTop: "23px" }}>
              <div className={styles.tagItem}>รับที่ร้าน</div>
              <div className={styles.tagItem}>จัดส่ง</div>
            </div>
          </div>

          <Carousel
            touchMove={true}
            draggable={true}
            swipeToSlide={true}
            touchThreshold={50}
            focusOnSelect={true}
            autoplay
          >
            <Row>
              <Col>
                <div className={styles.productWrapper}>
                  {!item?.products?.length ? (
                    <>
                      <div className={styles.productNotFoundWrapper}>
                        ยังไม่มีสินค้า
                      </div>
                    </>
                  ) : (
                    <>
                      {item?.products.slice(0, 4).map((product: any, index: number) => (
                        <Link to={`/shops/product-detail/?from=${fromPage}&id=${product._id}`} key={index}>
                          <div className={styles.productItem} key={product._id}>
                            <div className={styles.imageWrapper}>
                              {product?.product?.files &&
                              product?.product?.files.length ? (
                                <>
                                  <div
                                    className={styles.imageBox}
                                    style={{
                                      backgroundImage: `url('${
                                        product.product?.files &&
                                        product.product?.files.length
                                          ? product.product.files[0]
                                          : ""
                                      }')`,
                                      backgroundColor: "inherit",
                                    }}
                                  ></div>
                                </>
                              ) : (
                                <>
                                  <div className={styles.imageBox}></div>
                                </>
                              )}
                            </div>
                            <div className={styles.detailWrapper}>
                              <div className={styles.nameProduct}>
                                {product.product?.productName}
                              </div>
                            </div>
                            <div className={styles.detailWrapper}>
                              <div className={styles.price}>
                                ฿{product.price}
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Carousel>
        </div>
        <div className={styles.secondWrapper}>
          <div className={styles.seeMoreWrapper}>
            <Link className={styles.seeMore} to={`/shops/?id=${item._id}`}>
              ดูสินค้าเพิ่ม
            </Link>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className={styles.shopsWrapper}>
      {items.map((item: any, index: number) => (
        <div className={styles.item} key={index}>
          {checkPromotion(item.code) ? (
            <div>
              <Badge.Ribbon
                text={getShopPromotion(item.code)}
                color="volcano"
              >
                {ShopDetailForm(item)}
              </Badge.Ribbon>
            </div>
          ) : (
            ShopDetailForm(item)
          )}
        </div>
      ))}
      </div>
  );
};
export default ShopListWithProducts;
